var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`banner-button banner-button--${_vm.color}`,on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticClass:"mr-8",attrs:{"icon":_vm.icon}}),_vm._t("default"),_c('div',{staticClass:"arrow"},[_c('font-awesome-icon',{staticClass:"arrow",attrs:{"icon":"chevron-right"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }